import React from 'react';
import { connect } from 'react-redux';
import { incrementStep, decrementStep, setFormData, verifyAddress, setOverSixtyDays, setNotClosed } from '../redux/actions';
import AddressVerificationModal from "../../shared/address-verification-modal";
import Comps from '@owenscorning/react-library';
import RadioButton from '../../shared/RadioButton';
import styled from '@emotion/styled';
import TextInput from "../../shared/TextInput/index.jsx";
import { BackArrow } from "../../shared/svgIcons.jsx";

const AddressGroup = Comps.Connect.FormElements.AddressGroup;
const Select = Comps.Connect.FormElements.Select;

const StepWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 35rem;
  width: 100%;
`;

const Header = styled.h3`
  font-family: 'OCRoboto';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  padding-top: 1rem;
`;

const RadioContainer = styled.div`
  border: 1px solid #6D6D6D;
  margin-bottom: 1rem;
  max-width: 35rem;
  min-width: 48%;
  padding: 1rem;
`;

const HalfRadioContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const NextButton = styled.button`
  background-color: #D40F7D;
  border: none;
  color: #FFFFFF;
  cursor: pointer;
  font-size: 18px;
  padding: .5rem;
  width: 100%;

  :disabled {
    background-color: #D8D8D8;
    cursor: default;
  }
`;

const BackWrapper = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 2rem;
  width: 100%;
`;

const BlurredText = styled.p`
  filter: blur(2px);
  margin-top: 0;
  padding-bottom: 1.5rem;
`;

const ThirdInputContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 1rem;

  > div {
    width: 32%;
  }
`;

const InputWrapper = styled.div`
  width: 100%;
  padding: 0.5em 0;
`;


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

const monthSelectOptions = () => {
  const monthOptions =  months.map((month, index) => <option key={month} value={index + 1}>{month}</option>)
  const placeholder = <option disabled="" hidden value="false"></option>

  return(
    [placeholder, ...monthOptions]
  );
};

const OverSixtyDaysMessage = ({ setShow }) => {

  _satellite.track('form-error', { errorCode: 'NA', errorMsg: 'You must do this within 60 days of the close date' });

  return (
    <div>
      <BackWrapper
        data-track="form-back"
        data-track-form-name="Warranty Transfer"
        data-track-form-step="step 2 - property address"
        onClick={() => setShow(false)}>
        <BackArrow width="21" height="12" />
        <p>Back</p>
        <BlurredText>When did you close on this property?</BlurredText>
      </BackWrapper>
      <Header>We’re sorry, it doesn’t look like this warranty is available for transfer.</Header>
      <p>You must do this within 60 days of the close date. If you think this is an error, please contact us and a representative will be glad to assist:</p>
      <Header>1-800-ROOFING</Header>
    </div>
  )
};

const NotClosedYetMessage = ({ setShow }) => {

  _satellite.track('form-error', { errorCode: 'NA', errorMsg: 'Please initiate the warranty transfer once your property has closed.' });

  return (
    <div>
      <BackWrapper
        data-track="form-back"
        data-track-form-name="Warranty Transfer"
        data-track-form-step="step 2 - property address"
        onClick={() => setShow(false)}>
        <BackArrow width="21" height="12" />
        <p>Back</p>
        <BlurredText>When did you close on this property?</BlurredText>
      </BackWrapper>
      <Header>Your property must be closed on in order to transfer a warranty.</Header>
      <p>Please initiate the warranty transfer once your property has closed. You must do this within 60 days of the close date. If you have any questions, please contact a representative at:</p>
      <Header>1-800-ROOFING</Header>
    </div>
  )
};

const mapStateToProps = state => (
  {
    formData: state.formData,
    propertyAddress: state.formData.propertyAddress,
    metadata: state.metadata,
    notClosedYet: state.notClosedYet,
    overSixtyDays: state.overSixtyDays,
  }
);

const Step2 = ( { decrementStep, setFormData, verifyAddress, formData, propertyAddress, overSixtyDays, notClosedYet, setOverSixtyDays, setNotClosed } ) => {
  const validated = (formData.closeDateDay && (formData.closeDateYear && formData.closeDateYear.length == 4) && formData.closeDateMonth && propertyAddress && !(overSixtyDays || notClosedYet));

  function clearDate(value) {
    setFormData({closeDateDay: '', closeDateYear: '', closeDateMonth: 'false'})
    setOverSixtyDays(value);
    setNotClosed(value);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  if  (overSixtyDays || notClosedYet) {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  return (
    <StepWrapper>
      {overSixtyDays && <OverSixtyDaysMessage setShow={(value) => clearDate(value)} />}
      {notClosedYet && <NotClosedYetMessage setShow={(value) => clearDate(value)} />}
      <div style={{display: (overSixtyDays || notClosedYet) ? "none" : "block"}}>
        <BackWrapper
          data-track="form-back"
          data-track-form-name="Warranty Transfer"
          data-track-form-step="step 2 - property address"
          onClick={decrementStep}
        >
          <BackArrow width="21" height="12" />
          <p>Back</p>
          <BlurredText>What is your role?</BlurredText>
        </BackWrapper>
        <p>Thanks! Next, we’ll just need some information to locate the warranty. To begin,</p>
        <Header>What is the property address?</Header>
        <HalfRadioContainer>
          <RadioContainer>
              <RadioButton
                value={'US'}
                fieldKey={'countrySelected'}
                htmlAttributes={{}}
              >
                <label>United States</label>
              </RadioButton>
            </RadioContainer>
            <RadioContainer>
              <RadioButton
                value={'CA'}
                fieldKey={'countrySelected'}
                htmlAttributes={{}}
              >
                <label>Canada</label>
              </RadioButton>
            </RadioContainer>
          </HalfRadioContainer>
          <AddressGroup
            value={propertyAddress}
            onChange={(address) => { setFormData({ propertyAddress: address }) }}
            suggestionEndpoint={MDMS_URL + '/api/v1/smarty/suggestions'}
            showComplaints={false}
            country={formData.countrySelected}
          />
        <Header>When did you close on this property?</Header>
        <ThirdInputContainer>
          <InputWrapper>
            <Select
              invalidInput={false}
              options={monthSelectOptions()}
              placeHolderText={'Month'}
              onChange={(month) => { setFormData({ closeDateMonth: month }) }}
              selected={formData.closeDateMonth || false}
            />
          </InputWrapper>
          <InputWrapper>
            <TextInput
              fieldKey={'closeDateDay'}
              value={formData.closeDateDay || ''}
              htmlAttributes={{
                placeholder: 'Day',
                pattern: "[0-9]*",
              }}
            />
          </InputWrapper>
          <InputWrapper>
            <TextInput
              fieldKey={'closeDateYear'}
              value={formData.closeDateYear || ''}
              htmlAttributes={{
                placeholder: 'Year',
                pattern: "[0-9]*",
              }}
            />
          </InputWrapper>
        </ThirdInputContainer>

        <NextButton
          data-track="form-advance"
          data-track-form-name="Warranty Transfer"
          data-track-form-step="step 2 - property address"
          onClick={verifyAddress}
          disabled={!validated}
        >
          Next
        </NextButton>
        <AddressVerificationModal />
      </div>
    </StepWrapper>
  )
};

const mapDispatchToProps = dispatch => (
  {
    incrementStep: () => dispatch(incrementStep()),
    decrementStep: () => dispatch(decrementStep()),
    setFormData: (hash) => dispatch(setFormData(hash)),
    verifyAddress: () => dispatch(verifyAddress()),
    setOverSixtyDays: (value) => dispatch(setOverSixtyDays(value)),
    setNotClosed: (value) => dispatch(setNotClosed(value)),
  }
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Step2);
